export const responsiveConstant = 1200;
